// extracted by mini-css-extract-plugin
export default {"card":"CampaignCard_card__s3Ezm","imageWrapper":"CampaignCard_imageWrapper__tv1Ug","content":"CampaignCard_content__g+M84","button":"CampaignCard_button__KzdW0"};